/**
 * DevExtreme (esm/ui/number_box/number_box.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import NumberBoxMask from "./number_box.mask";
registerComponent("dxNumberBox", NumberBoxMask);
export default NumberBoxMask;
